<template>
  <div class="entrance-header">
    <div class="flex justify-between items-center pt-[0.75rem]">
      <div class="vector" @click="emit('openHistory')">
        <IconSvgUse use="icon-statistic-3" class="icon-vector" />
        <span class="text-vector">{{ $t('niuniu.history') }}</span>
      </div>
      <div class="vector" @click="emit('openTrendChart')">
        <IconSvgUse use="icon-statistic-3" class="icon-vector" />
        <span class="text-vector">{{ $t('niuniu.trend') }}</span>
      </div>
    </div>
    <img class="top-img" src="../img/indoor/topImg_BULL.webp" />
    <!-- 庄家 -->
    <div class="banker-container">
      <img src="../img/indoor/cow-banker.png" class="icon-banker" alt="">
      <!-- <IconSvgUse use="icon-cow-banker" class="icon-banker" /> -->
      <span class="text">{{ $t('niuniu.zhuang') }}</span>
    </div>

    <div class="entrance-main">
      <!-- 其他玩家永久筹码 -->
      <permanent-chip v-for="chip in permanentChips" :key="chip.id" :value="chip.value" :player-name="chip.playerName"
        :area="chip.area" :style="chip.style" />

      <!-- 等待下一轮 -->
      <div class="timer" v-if="gameStatus == 'PREPARING_NEXT_ROUND'">
        <IconSvgUse disabled use="icon-timer2" class="icon-timer" />
      </div>

      <!-- 游戏中 -->
      <div class="timer" v-if="gameStatus == 'BETTING'">
        <IconSvgUse v-if="countdownValue > 5" use="icon-timer2" class="icon-timer text-[green]" />
        <div v-else-if="countdownValue < 6" class="icon-timer-heartbeat">
          <IconSvgUse use="icon-timer2" class="icon-timer text-[#FF5C00]" />
        </div>
        <div class="text-timer">{{ countdownValue }}</div>
        <div class="sec-timer">{{ $t('niuniu.sec') }}</div>
      </div>

      <!-- 停止下注 -->
      <div class="timer" v-if="gameStatus == 'STOP_BETTING'">
        <IconSvgUse use="icon-timer2" class="icon-timer text-[#FF5C00]" />
        <div class="text-timer">{{ countdownValue }}</div>
        <div class="sec-timer">{{ $t('niuniu.sec') }}</div>
      </div>

      <!-- 停止下注、开奖 -->
      <!-- <div class="timer !items-center" v-if="gameStatus == 'SHOW_RESULT' || gameStatus == 'STOP_BETTING'"> -->
      <div class="timer !items-center" v-if="gameStatus == 'SHOW_RESULT'">
        <!-- <IconSvgUse use="icon-awarding" class="icon-timer" /> -->
         <img class="w-[1.688rem] h-[1.688rem]" src="../img/indoor/liveCasino.png" alt="">
        <div class="sec-timer">{{ $t('niuniu.awarding') }}</div>
      </div>

      <!-- 换房 -->
      <div class="operate change-room" @click="emit('openSelectRoom')">
        <IconSvgUse use="icon-autorenew" class="icon-refresh" />
        <div class="change-room-text">{{ $t('niuniu.change') }}</div>
      </div>
      <div class="pocker-content">
        <div class="pocker-container">
          <div class="pocker">
            <PokerCard v-for="(card, index) in bankerCards" :key="index"
              :ref="el => setDealerCardRef(index, el as HTMLElement | null)" :class="'pocker-img' + index" :card="card"
             :isFaceUpProp="false" width="3.125rem" height="3.125rem" :style="{ top: '0px', position: 'absolute' }" />
          </div>
          <!-- 下注结算 -->
          <transition name="betting-result-slide">
            <div class="betting-result" v-show="showBettingResult">
              <div class="relative">
                <div class="betting-result-content" :class="getBettingResultClass(bankerHandName)">
                  <!-- 特殊牌型特殊处理UI 五花牛/四炸/五小牛-->
                  <div v-if="locale == 'cn' && bankerHandType == 11 || bankerHandType == 12 || bankerHandType == 13"
                    class="text !text-[1.125rem]">
                    {{ bankerHandName }}
                  </div>
                  <div v-else-if="locale == 'en' && bankerHandType == 11"
                    class="text !text-[0.813rem] !leading-[0.875rem] flex flex-col item-center justify-center text-center">
                    <span>Five</span>
                    <span>Cards</span>
                  </div>
                  <div v-else-if="locale == 'en' && bankerHandType == 12"
                    class="text !text-[0.813rem] !leading-[0.875rem] flex flex-col item-center justify-center text-center">
                    <span>Four</span>
                    <span>Kind</span>
                  </div>
                  <div v-else-if="locale == 'en' && bankerHandType == 13"
                    class="text !text-[0.813rem] !leading-[0.875rem] flex flex-col item-center justify-center text-center">
                    <span>Five</span>
                    <span>Small</span>
                  </div>
                  <div v-else-if="locale == 'en' && bankerHandType == 10"
                    class="text !text-[0.813rem] !leading-[0.875rem] flex flex-col item-center justify-center text-center">
                    <span>Bull</span>
                    <span>Bull</span>
                  </div>
                  <div v-else class="text" :class="[
                    locale == 'cn' ? '!text-[1.25rem]' : '!text-[0.875rem]'
                  ]">{{ bankerHandName }}</div>


                  <div class="multiple" v-if="bankerHandType !== 0">X{{ bankerMultiplier }}</div>
                </div>
                <!-- 背景雾图 -->
                <img :src="getHandTypeBgImage(bankerHandType)" class="hand-type-bg-fog" alt="">
              </div>
            </div>
          </transition>
          <div class="result">
            <div class="result-item" :class="item.typeId != 0 ? 'result-item-active' : ''"
              v-for="(item, index) in lastRoundResult.banker" :key="index">
              <!-- 五花牛 -->
              <div class="result-item-text flex flex-nowrap items-center justify-center gap-[0.063rem] break-keep" v-if="item.typeId == 11">
                  <span v-if="locale == 'cn'">五花</span>
                  <template v-else>
                    <span>5</span>
                    <IconSvgUse use="icon-flower-red" size="0.875rem" />
                  </template>
              </div>
              <!-- 四炸 -->
              <div class="result-item-text flex flex-nowrap items-center justify-center gap-[0.063rem] break-keep" style="width:max-content;" v-else-if="item.typeId == 12">
                  <span v-if="locale == 'cn'">四炸</span>
                  <span v-else>Four kind</span>
              </div>
              <!-- 五小牛 -->
              <div class="result-item-text flex flex-nowrap items-center justify-center gap-[0.063rem] break-keep" v-else-if="item.typeId == 13">
                  <span v-if="locale == 'cn'">五小</span>
                  <template v-else>
                    <span>5</span>
                    <IconSvgUse use="icon-small-green" size="0.875rem" />
                  </template>
              </div>
              <div class="flex flex-nowrap items-center justify-center gap-[0.063rem]" v-else>
                <IconSvgUse v-if="item.typeId == 0" use="icon-cow-55657E" size="0.875rem" />
                <IconSvgUse v-else use="icon-cow-white70" size="0.875rem" />
                <span class="result-item-text">{{ item.type }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 在线人数 -->
      <div class="operate online" @click="emit('openPlayerList')">
        <IconSvgUse use="icon-online" class="icon-online" />
        <div class="change-room-text">{{ onLineCount }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, defineComponent } from 'vue';
import * as bettingAnimation from '../ts/bettingAnimation';
import { cardRefs } from '../ts/cardAnimation';
import PokerCard from './PokerCard.vue';
import { getBettingResultClass } from '../ts/gameTps';
import bullNoBg from '../img/indoor/bull-no_bg.png'
import bull1Bg from '../img/indoor/bull1_bg.png'
import bullBullBg from '../img/indoor/bull-bull_bg.png'
import bullNBg from '../img/indoor/bull-n_bg.png'
const { t: $tFn } = useNuxtApp().$i18n;
const { locale } = useI18n();

// 根据牌型ID获取背景图片
const getHandTypeBgImage = (niuType: number): string => {
  if (niuType === 0) return bullNoBg // 无牛
  if (niuType === 10) return bullBullBg // 牛牛
  if (niuType >= 1 && niuType <= 9) return bullNBg // 牛一到牛九
  return bull1Bg // 默认
}

// 永久筹码子组件
const PermanentChip = defineComponent({
  props: {
    value: Number,
    playerName: String,
    area: String,
  },
  setup(props) {
    // 获取筹码 PNG 图片路径
    const chipPngPath = bettingAnimation.getChipPngPath(props.value || 1);

    return () => h('img', {
      class: 'other-player-permanent-chip',
      src: chipPngPath,
      alt: `chip-${props.value}`,
      draggable: false,
      style: {
        width: '0.938rem',
        height: '0.938rem',
        position: 'absolute',
        objectFit: 'contain',
        pointerEvents: 'none'
      },
      'data-chip-value': props.value,
      'data-player': props.playerName,
      title: `${props.playerName}: ${props.value}`
    });
  }
});

// 接收父组件传递的倒计时值
const props = defineProps({
  countdownValue: {
    type: Number,
    default: 0
  },
  gameStatus: {
    type: String,
    default: ''
  },
  bankerCards: {
    type: Array,
    default: []
  },
  onLineCount: {
    type: Number,
    default: 0
  },
  lastRoundResult: {
    type: Object,
    default: {}
  }
});

// 卡牌数据结构从cardAnimation.ts导入，这里仅定义接口以供类型检查
interface Card {
  suit: 'hearts' | 'diamonds' | 'clubs' | 'spades';
  rank: 'A' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | 'J' | 'Q' | 'K';
  value: number;
};

// 庄家牌型结果
const bankerHandType = ref();

// 庄家牌型结果 名称
const bankerHandName = ref('');

// 庄家倍率 - 存储服务器返回的实际倍率
const bankerMultiplier = ref<number>(1);

// 是否显示下注结果
const showBettingResult = ref(false);

// 设置庄家卡牌引用 - 用于将DOM元素映射到统一的引用系统
const setDealerCardRef = (index: number, el: HTMLElement | null) => {
  if (el) {
    // 使用统一的引用格式，以便cardAnimation.ts中的动画函数能找到卡牌元素
    const key = `area4-card${index}`; // 庄家的areaIndex为4
    if (cardRefs && cardRefs.value) {
      cardRefs.value.set(key, el);
    }
  }
}

// 定义事件
const emit = defineEmits<{
  otherPlayerBet: [areaId: string, chipValue: number, playerName: string]
  openSelectRoom
  openPlayerList
  openTrendChart
  openHistory
}>();

// 对外暴露接收牌组和第五张牌翻转完成回调的方法
defineExpose({
  bankerHandType,
  bankerHandName,
  bankerMultiplier,
  showBettingResult
});

// 其他玩家永久筹码数组
const permanentChips = ref([]);

</script>
<style lang="scss" scoped>
/* 心跳动画 - 倒计时5秒及以下时触发 */
@keyframes heartbeat {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.3);
  }

  100% {
    transform: scale(1);
  }
}

/* 其他玩家永久筹码样式 */
:deep(.other-player-permanent-chip) {
  position: absolute;
  width: 0.938rem;
  height: 0.938rem;
  z-index: 5;
  cursor: pointer;

  &:hover {
    filter: brightness(1.2);
    transform: scale(1.1);
    z-index: 10;
  }
}

/* 样式保持不变 */
.entrance-header {
  margin: 0 1rem;
  position: relative;

  .vector {
    position: relative;
    z-index: 20;
    border-radius: 0.313rem;
    padding: 0.125rem 0.188rem;
    background: #0000004D;
    backdrop-filter: blur(0.313rem);
    color: white;
    display: flex;
    align-items: center;
    gap: 0.125rem;

    .text-vector {
      font-weight: 500;
      font-size: 0.75rem;
      line-height: 1.125rem;
      letter-spacing: 0.031rem;

    }

    .icon-vector {
      width: 1.125rem;
      height: 1.125rem;
    }
  }

  .banker-container {
    width: 2.375rem;
    height: 2.375rem;
    margin: 0 auto;
    position: relative;
    margin-top: 0.938rem;
    display: flex;
    align-items: center;
    justify-content: center;

    .icon-banker {
      width: 2.375rem;
      height: 2.375rem;
    }

    .text {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 10;
      color: var(--bet-corgi-color-white-100, #FFF);
      font-size: 0.75rem;
      font-weight: 700;
      line-height: 0.75rem;
      /* 100% */
      text-transform: capitalize;
    }
  }

  .entrance-main {
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    padding-top: 2.063rem;

    .timer {
      position: absolute;
      top: -0.4375rem;
      right: 0.813rem;
      border-radius: 0.375rem;
      padding: 0.188rem 0.313rem 0.125rem 0.313rem;
      background: #0D131C;
      border: 0.031rem solid #2283F680;
      display: flex;
      align-items: center;
      gap: 0.063rem;


      .icon-timer {
        width: 1.688rem;
        height: 1.688rem;
      }

      .icon-timer-heartbeat {
        display: inline-flex;
        align-items: center;
        animation: heartbeat 1s ease-in-out infinite;
      }

      .text-timer {
        font-weight: 500;
        font-size: 1rem;
        line-height: 1rem;
        letter-spacing: -0.031rem;
        color: #FFFFFFB2;
      }

      .sec-timer {
        font-weight: 400;
        font-size: 0.625rem;
        line-height: 0.75rem;
        letter-spacing: -0.031rem;
        color: #FFFFFF66;
      }
    }

    .pocker-content {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;

      .pocker-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        // justify-content: center;
        /* 垂直居中所有内容 */
        height: 5.8125rem;
        position: relative;
      }

      .pocker {
        width: 10.625rem;
        height: 3.125rem;
        /* 固定高度确保对齐 */
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        z-index: 3;
        // overflow: visible;
        :deep(.icon-bottom){
            height: 0.938rem;
            width: 0.938rem;
            bottom: 0.25rem;
        }

        /* 添加对所有直接子元素的绝对定位 */
        >* {
          top: 0 !important;
          margin-top: 0 !important;
        }

        /* 同时支持img元素和PokerCard组件 */
        img,
        :deep(.card) {
          position: absolute;
          top: 0;
          /* 统一高度设置，与直接子元素保持一致 */
          transform: translateX(-50%);
          /* 仅水平方向的变换 */
        }

        /* 卡牌位置样式 - 直接为PokerCard组件定位 */
        .pocker-img0 {
            left: calc(50% - 3.125rem);
            /* 左侧第二张 */
        }

        .pocker-img1 {
            left: calc(50% - 1.563rem);
            /* 左侧第一张 */
        }

        .pocker-img2 {
            left: 50%;
            /* 中间 */
        }

        .pocker-img3 {
            left: calc(50% + 1.563rem);
            /* 右侧第一张 */
        }

        .pocker-img4 {
            left: calc(50% + 3.125rem);
            /* 右侧第二张 */
        }
      }

      /* 庄家牌型背景雾图 - 在右侧下层 */
      .hand-type-bg-fog {
        width: 5.125rem;
        height: 4.5rem;
        position: absolute;
        bottom: -1.375rem;
        right: -1.25rem;
        z-index: -1;
        pointer-events: none;
      }

      .betting-result {
        position: absolute;
        top: 0.875rem;
        left: 50%;
        transform: translateX(-50%);
        z-index: 4;

        /* 确保动画流畅 */
        will-change: transform, opacity;

        .betting-result-content {
          height: 2.563rem;
          width: fit-content;
          min-width: 7.5rem;
          padding: 0 0.938rem;
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          gap: 0.063rem;
        }

        .text {
          font-weight: 600;
          font-size: 1.25rem;
          line-height: 1.5rem;
          letter-spacing: 0;
          color: white;
          display: flex;
          flex-wrap: nowrap;

          &.wrap-text {
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            line-height: 1.25rem;
          }
        }

        .multiple {
          width: auto;
          height: 1.375rem;
          background-repeat: no-repeat;
          background-size: cover;
          font-weight: 800;
          font-size: 0.75rem;
          line-height: 0.75rem;
          letter-spacing: 0.031rem;
          padding: 0.188rem;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      /* 庄家开奖结果向下弹跳+放大回弹动画 */
      .betting-result-slide-enter-active {
        animation: banker-result-bounce 0.4s ease-out;
      }

      .betting-result-slide-leave-active {
        animation: banker-result-fade-out 0.2s ease-out;
      }

      @keyframes banker-result-bounce {
        0% {
          transform: translateX(-50%) translateY(-1.875rem) scale(0.3);
          opacity: 0;
        }

        60% {
          transform: translateX(-50%) translateY(0) scale(1.08);
          opacity: 1;
        }

        100% {
          transform: translateX(-50%) translateY(0) scale(1);
          opacity: 1;
        }
      }

      @keyframes banker-result-fade-out {
        0% {
          transform: translateX(-50%) translateY(0) scale(1);
          opacity: 1;
        }

        100% {
          transform: translateX(-50%) translateY(-1.25rem) scale(0.8);
          opacity: 0;
        }
      }

      .betting-result0 {
        background-image: url(../img/indoor/bull-no.webp);
      }

      .betting-result1 {
        background-image: url(../img/indoor/bull1.webp);

        .multiple {
          background-image: url(../img/indoor/bg1.png);
        }
      }

      .betting-result2 {
        background-image: url(../img/indoor/bull-n.webp);

        .text {
          text-shadow:
            0.063rem 0.063rem 0 #FF4D00,
            /* 右下橙色边缘 */
            -0.063rem -0.063rem 0 #6740FF;
          /* 左上紫色边缘 */
        }

        .multiple {
          background-image: url(../img/indoor/bg2.png);
        }
      }

      .betting-result3 {
        background-image: url(../img/indoor/bull-bull.webp);

        .text {
          text-shadow:
            -0.063rem -0.063rem 0 #FF4D00,
            /* 左上 */
            0.063rem -0.063rem 0 #FF4D00,
            /* 右上 */
            -0.063rem 0.063rem 0 #FF4D00,
            /* 左下 */
            0.063rem 0.063rem 0 #FF4D00;
          /* 右下 */
        }

        .multiple {
          background-image: url(../img/indoor/bg3.png);
        }
      }

      .result {
        padding: 0.25rem 0.375rem;
        border-radius: 0.75rem;
        border: 0.031rem solid var(--betcorgi-bg006_2A3546, #2A3546);
        background: var(--betcorgi-bg011_0D131C, #0D131C);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 0.313rem;

        &-item {
          height: 1.25rem;
          padding: 0.188rem;
          border-radius: 0.375rem;
          border: 0.063rem solid var(--betcorgi-bg006_2A3546, #2A3546);
          background: var(--betcorgi-bg006_2A3546, #2A3546);
          box-sizing: border-box;
          display: flex;
          align-items: center;
          margin-right: 0.188rem;

          .icon-cow {
            width: 0.875rem;
            height: 0.875rem;
            // color: #FFFFFFB2;
          }

          &-text {
            font-weight: 600;
            font-size: 0.625rem;
            line-height: 0.625rem;
            color: white;
          }

          &-active {
            border: 0.063rem solid var(--cow-002, #3C1AEA);
            background: var(--cow-001, #3D57FF);
          }
        }
        &-item:last-of-type {
          margin-right: 0;
        }
      }

      .banker {
        width: 4.375rem;
        height: 1.25rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: url(../img/indoor/rectangle.png);
        background-repeat: no-repeat;
        background-size: cover;
        color: #1BB83D;
        font-weight: 700;
        font-size: 0.75rem;
        line-height: 0.75rem;
      }
    }

    .operate {
      border-radius: 0.313rem;
      padding: 0.125rem 0.375rem;
      background: #0000004D;
      z-index: 0;
      backdrop-filter: blur(0.625rem);
      width: fit-content;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 0.938rem;

      &-text {
        font-weight: 500;
        font-size: 0.625rem;
        line-height: 0.625rem;
        letter-spacing: 0.031rem;
        color: white;
      }
    }
  }

  .change-room {
    top: 7.25rem;
    left: 1rem;

    .icon-refresh {
      width: 1.5rem;
      height: 1.5rem;
    }
    .change-room-text{
      font-size: 0.625rem;
    }
  }

  .online {
    top: 7.25rem;
    right: 1rem;

    .icon-online {
      width: 1.5rem;
      height: 1.5rem;
    }
  }
}

.top-img {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
}
/* 在长屏幕时高度自动增加，只在高度超过 718px 时生效 */
@media (min-height: 812px){
  // .pocker{
  //   height: 2.875rem !important;
  //           .card{
  //               width: 2.188rem !important;
  //               height: 2.875rem !important;
  //               .icon-bottom{
  //                 width: 1.438rem !important;
  //                 height: 1.438rem !important;
  //               }
  //           }
  // }
}
</style>